
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'TagX'
})
export default class TagX extends Vue {}
